import styled, { css } from 'styled-components/macro';

import Row from 'components/data-visualization/Table/Row';
import Cell from 'components/data-visualization/Table/Cell';
import EntityItem from 'components/base/EntityItem/EntityItem';
import { ArtworkWrapper } from 'components/base/EntityItem/EntityItem.style';

import { definitionValue } from 'styles/base-classes';
import modularScale from 'styles/helpers/modular-scale';
import { ThemeProps } from 'types/styled';

export const StyledEntityItem = styled(EntityItem)<ThemeProps<'div'>>`
  padding: ${({ theme }): string => theme.spacing.small} 0 0;

  @media screen and (min-width: 50em) {
    padding: ${({ theme }): string => theme.spacing.small} 0;
  }

  &:active,
  &:hover {
    background: none;
  }
`;

export const CellContent = styled('div')`
  ${definitionValue};
  font-weight: 400;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  flex: 1 1 auto;

  @media screen and (min-width: 50em) {
    justify-content: flex-end;
  }
`;

export const EntityCell = styled(Cell)<ThemeProps<'td'>>`
  display: block;

  ${({ isFaded }): any =>
    isFaded &&
    css`
      opacity: 0.3;
    `}

  &:first-of-type {
    padding: 0;

    ${CellContent} {
      justify-content: flex-start;
    }
  }

  &:last-of-type {
    margin-right: 0;
    flex-basis: 100%;
  }

  &:first-child:last-child {
    padding-bottom: ${({ theme }): string => theme.spacing.small};
  }

  @media screen and (min-width: 50em) {
    display: table-cell;

    &,
    &:first-of-type {
      padding-top: 0;
      padding-bottom: 0;
    }

    &:first-of-type {
      font-weight: 600;
    }

    &:first-child:last-child {
      padding-bottom: 0;
    }
  }
`;

export const TableRow = styled(Row)<ThemeProps<'tr'>>`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }): string => theme.LightGrey};

  ${(p): string =>
    p.isEditMode &&
    `
    &:hover {
    background: initial;
  }
  `}

  td:not(:nth-of-type(2)) {
    font-size: ${modularScale(-1)};
  }

  td:first-of-type {
    width: 2em;
    text-align: right;
    span {
      margin-right: 0.75em;
    }
  }

  td.buttonColumn {
    text-align: right;
  }

  ${({ isHighlighted, theme }): string =>
    isHighlighted &&
    `
      background: ${theme.Sand};

      ${ArtworkWrapper} {
        transform: translateX(0.25em);
      }
    `}

  ${({ isDeleted }): string =>
    isDeleted &&
    `
    td:first-of-type,
    td:nth-of-type(2) {
      opacity: 0.5;
    }  

    h3 {
      text-decoration: line-through;
    }
    `}

  @media screen and (min-width: 50em) {
    display: table-row;
    border-bottom: 0;

    td {
      border-bottom: 1px solid ${({ theme }): string => theme.LightGrey};
    }
  }
`;
